<template>
  <div class="p-6">
    <p class="card-title">Admin</p>
    <div class="box center_horizontal">
      <div class="columns pt-4">
        <router-link
          :to="{ name: 'admin-languages' }"
          class="column admin_link button is-light"
          >Languages</router-link
        >
        <router-link
          :to="{ name: 'admin-history-companies' }"
          class="column admin_link button is-light"
          >History Companies</router-link
        >
        <router-link
          :to="{ name: 'admin-skills' }"
          class="column admin_link button is-light"
          >Skills</router-link
        >
        <router-link
          :to="{ name: 'admin-education-institutions' }"
          class="column admin_link button is-light"
          >Education Institutions</router-link
        >
      </div>
      <div class="columns">
        <router-link
          :to="{ name: 'admin-education-degrees' }"
          class="column admin_link button is-light"
          >Education Degrees</router-link
        >
        <router-link
          :to="{ name: 'admin-education-courses' }"
          class="column admin_link button is-light"
          >Education Courses</router-link
        >
        <router-link
          :to="{ name: 'admin-job-titles' }"
          class="column admin_link button is-light"
          >Job Titles</router-link
        >
        <router-link
          :to="{ name: 'admin-filters' }"
          class="column admin_link button is-light"
          >Filters</router-link
        >
      </div>
      <div class="columns">
        <router-link
          :to="{ name: 'admin-questions' }"
          class="column admin_link button is-light"
          >Questions</router-link
        >
        <a
          target="_blank"
          :href="
            $settings.get({ path: 'base_api_url' }) + '/sidekiq/queues'
          "
          class="column admin_link button is-light"
          >Sidekiq</a
        >
        <router-link
          :to="{ name: 'admin-blog' }"
          class="column admin_link button is-light"
          >Blog</router-link
        >
        <a @click="backup()" class="column admin_link button is-light"
          >Backup</a
        >
      </div>
      <div class="columns">
        <a
          @click="capacityReport('day', 'capacity_report')"
          class="column admin_link button is-light"
          >Daily Capacity Report</a
        >
        <a
          @click="capacityReport('week', 'capacity_report')"
          class="column admin_link button is-light"
          >Weekly Capacity Report</a
        >
        <router-link
          :to="{ name: 'admin-owners-schedule' }"
          class="column admin_link button is-light"
          >Owners Schedule</router-link
        >
        <router-link
          :to="{ name: 'admin-feed-designators' }"
          class="column admin_link button is-light"
          >Feed Designators</router-link
        >
      </div>
      <div class="columns">
        <a
          @click="refreshPublicPositions"
          class="column admin_link button is-light"
          >Refresh Public Positions</a
        >
        <router-link
          :to="{ name: 'admin-outsource', query: { status: 'active' } }"
          class="column admin_link button is-light"
          >Outsource
        </router-link>
        <router-link
          :to="{ name: 'qr-code-generator' }"
          class="column admin_link button is-light">
          QRgenerator
        </router-link>
        <router-link
          :to="{ name: 'admin-huji' }"
          class="column admin_link button is-light"
          >Huji</router-link
        >
      </div>
      <div class="columns">
        <router-link
          :to="{
            name: 'admin-efforts',
            query: {
              recruiter: isSuperAdmin ? getRecruiterNames.join(',') : undefined,
              date_from: time_helper.getToday().toUTCString(),
              date_to: time_helper.getTomorrow().toUTCString()
            }
          }"
          class="column admin_link button is-light"
          >Efforts</router-link
        >
        <router-link
          :to="{
            name: 'admin-weekly-calendar',
            query: {
              recruiter: isSuperAdmin ? getRecruiterNames.join(',') : undefined
            }
          }"
          class="column admin_link button is-light"
          >Weekly Calendar</router-link
        >
        <router-link
          :to="{ name: 'settings' }"
          class="column admin_link button is-light">
          Settings
        </router-link>
        <router-link
          :to="{ name: 'developer-interview-articles' }"
          class="column admin_link button is-light">
          Developer Interview Articles
        </router-link>
      </div>
      <div class="columns">
        <router-link
          :to="{ name: 'vetting-recipes' }"
          class="column admin_link button is-light">
          Vetting Recipes
        </router-link>
        <router-link
          :to="{ name: 'admin-recommendations' }"
          class="column admin_link button is-light">
          Recommendations
        </router-link>
        <router-link
          :to="{ name: 'admin-list' }"
          class="column admin_link button is-light">
          Admins
        </router-link>
        <router-link
          :to="{ name: 'tag-list' }"
          class="column admin_link button is-light">
          Tags
        </router-link>
      </div>
      <div class="columns">
        <router-link
          :to="{ name: 'offer-statuses' }"
          class="column admin_link button is-light">
          Offer Statuses
        </router-link>
        <router-link
          :to="{ name: 'admin-designated-position' }"
          class="column admin_link button is-light">
          Create Designated Positions
        </router-link>
        <router-link
          :to="{ name: 'system-key-words' }"
          class="column admin_link button is-light">
          Key Words
        </router-link>
        <a
          @click="refreshShuffleCache"
          class="column admin_link button is-light"
          >Refresh Shuffle Cache</a
        >
      </div>
      <div class="columns">
        <a
          @click="capacityReport('day', 'capacity_feed_report')"
          class="column admin_link button is-light"
          >Daily Feed Capacity Report</a
        >
        <router-link
          :to="{ name: 'system-admin-requirments' }"
          class="column admin_link button is-light">
          Admin Requirments
        </router-link>
        <router-link
          :to="{ name: 'job-title-skills' }"
          class="column admin_link button is-light">
          Job Title Skills
        </router-link>
        <a
          @click="RestartServer"
          class="column admin_link button is-light">
          Restart Server
        </a>
      </div>
      <div class="columns">
        <router-link
          :to="{ name: 'system-position-recommendations' }"
          class="column admin_link button is-light">
          המלצות משרות
        </router-link>
        <button
          @click="openWhatsappTemplatesModal"
          class="column admin_link button is-light">
          Position offer Whatsapp text
        </button>
        <router-link
          :to="{ name: 'chatbot-conversations' }"
          class="column admin_link button is-light">
          שיחות וואטסאפ פעילות
        </router-link>
        <router-link
          :to="{ name: 'vector-match-test' }"
          class="column admin_link button is-light">
          Vector Match Test
        </router-link>
      </div>
      <div class="columns">
        <!-- Internal-only entry point: the 24h pipeline funnel deliberately has
             no sidebar item, it is reached from here. -->
        <router-link
          :to="{ name: 'pipeline-funnel' }"
          class="column admin_link button is-light">
          משפך 24 שעות
        </router-link>
      </div>
    </div>

    <!-- Modal for Whatsapp Templates -->
    <div class="modal" :class="{ 'is-active': showWhatsappTemplatesModal }">
      <div class="modal-background" @click="closeWhatsappTemplatesModal"></div>
      <div class="modal-card" style="width: 90%; max-width: 1200px;">
        <header class="modal-card-head">
          <p class="modal-card-title">הגדרות הודעות וואטסאפ ברירת מחדל</p>
          <button class="delete" @click="closeWhatsappTemplatesModal"></button>
        </header>
        <section class="modal-card-body">
          <SystemWhatsappTemplates />
        </section>
      </div>
    </div>
  </div>
</template>
<script>
import TimeHelper from '@/custom/classes/time_helper.js'
import { emit } from '@/custom/classes/my_utils.js'
import SystemWhatsappTemplates from '@/components/SystemWhatsappTemplates.vue'

export default {
  name: 'admin',
  components: {
    SystemWhatsappTemplates
  },
  data () {
    return {
      time_helper: new TimeHelper(),
      showWhatsappTemplatesModal: false
    }
  },
  computed: {
    isSuperAdmin () {
      return localStorage.getItem('super_admin') == 'true'
    },
    getRecruiterNames () {
      return this.$settings
        .get({ path: 'owners' })
        .map((recruiter) => recruiter.name)
    }
  },
  methods: {
    backup () {
      this.$network_utils
        .postEvent({
          event: 'backup_db',
          current_type: 'Applicant',
          current_resource_id: 1
        })
        .then(() => {
          emit('show_toast', { text: 'נשלח בהצלחה' })
        })
    },
    capacityReport (date_type, reportType) {
      this.$network_utils
        .postEvent({
          event: reportType,
          date_type: date_type,
          recipient: 'OFFICE_EMAIL_FROM',
          current_type: 'Applicant',
          current_resource_id: 1
        })
        .then(() => {
          emit('show_toast', { text: 'נשלח בהצלחה' })
        })
    },
    refreshPublicPositions () {
      this.$network_utils.refreshPublicPositions().then(() => {
        emit('show_toast', { text: 'רוענן בהצלחה' })
      })
    },
    refreshShuffleCache () {
      this.$network_utils.caller
        .request('get', '/outsource_data/reset_cache', 'admin_headers')
        .then(() => {
          emit('show_toast', { text: 'רוענן בהצלחה' })
        })
    },
    RestartServer () {
      this.$network_utils.postEvent({ event: 'restart_server', current_type: 'Applicant', current_resource_id: 1 })
    },
    openWhatsappTemplatesModal () {
      this.showWhatsappTemplatesModal = true
    },
    closeWhatsappTemplatesModal () {
      this.showWhatsappTemplatesModal = false
    }
  }
}
</script>
<style scoped>
.card {
  padding: 30px;
  padding-bottom: 0;
  width: 1200px;
  margin-top: 20px;
}
.admin_link {
  border-color: rgba(0, 0, 0, 0.3) !important;
  display: flex;
  margin-left: 30px;
  margin-right: 30px;
  align-items: center;
  justify-content: center;
  margin-bottom: 20px;
}
</style>
